import React, { type FC } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import InputText from "@/components/Atoms/Input";
import { type ContactUsFormControllerProps } from "@/components/ContactUsModal/types";

const ContactUsNameController: FC<ContactUsFormControllerProps> = ({
  control,
  errors,
}) => {
  const { t } = useTranslation();
  return (
    <Controller
      control={control}
      name="name"
      render={({
        field: { disabled, onChange, onBlur, value, ...inputProps },
      }) => (
        <InputText
          title={t("baseUser.table.name")}
          value={value}
          onChange={onChange}
          inputProps={{
            required: true,
            placeholder: t(`generic.placeholder.firstName`),
            onBlur: () => onChange(value.trim()),
            ...inputProps,
          }}
          inputTestId="contactUs-form-name"
          validationData={{
            errors: errors.name?.types,
            testId: "contactUs-form-name-validation",
          }}
        />
      )}
      rules={{
        required: t("generic.field.validation.required"),
      }}
    />
  );
};

export default ContactUsNameController;
